"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    regular: '624px',
    large: '1021px',
};
exports.default = breakpoints;
//# sourceMappingURL=breakpoints.js.map